import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Button,
  makeStyles,
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
  TextField,
} from "@material-ui/core";

import { Dropdown, Modal } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";

import Moment from "moment";
import {
  getSysLicenseList,
  uptLicense,
  deleteLicense,
  createLicenseKey,
  findLoginId,
  insertLicense,
  getLicenseDetail,
  getBotAdminLicenseList,
} from "../modules/api";
import MUIDataTable from "mui-datatables";
import { isObject } from "lodash";
import { setIn } from "formik";

export function LicenseSysManage() {
  const [listLoading, setListLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isAddShow, setIsAddShow] = useState(false);
  const [isFindIdShow, setIsFindIdShow] = useState(false);
  const [licenseList, setLicenseList] = useState([]);
  const [selectRowData, setSelectRowData] = useState([]);
  const [botList, setBotList] = useState([]);
  const [selectBot, setSelectBot] = useState();
  const [input, setInput] = useState({
    botAmount: "",
    term: "",
    startDate: Moment(new Date()).format("YYYY-MM-DD"),
    endDate: Moment(new Date()).format("YYYY-MM-DD"),
    licenseNumber: "",
    status: "Y",
    memo: "",
  });

  const [okLicense, setOkLicense] = useState(false);
  const [findId, setFindId] = useState();
  const [findIdList, setFindIdList] = useState([]);
  const [botAdminList, setBotAdminList] = useState([]);

  const [confirmBotAmount, setConfirmBotAmount] = useState(false);
  const [confirmTerm, setConfirmTerm] = useState(false);
  const [confirmLicenseNumber, setConfirmLicenseNumber] = useState(false);
  const [confirmLoginId, setConfirmLoginId] = useState(false);

  const [isAdd, setIsAdd] = useState(false);
  const [licenseNo, setLicenseNo] = useState();
  const [botStatus, setBotStatus] = useState(0);

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();

  const fetchData = async (value) => {
    try {
      console.log("vavavav", value);
      const botAdminList = await findLoginId();
      console.log("botAdminList", botAdminList);
      setBotAdminList(botAdminList.data);

      let licenseResult;
      if (value !== undefined && value !== "") {
        licenseResult = await getBotAdminLicenseList(value);
      } else {
        licenseResult = await getSysLicenseList();
      }

      // const licenseResult = await getSysLicenseList();
      console.log("licenseResult", licenseResult);
      setLicenseList(licenseResult.data);

      const nowDate = Moment(new Date()).format("YYYY-MM-DD");

      let list = [];
      let idx = 0;
      licenseResult.data.map((data, index) => {
        if (data.deletedAt === null) {
          var obj = new Object();
          obj.idx = idx + 1;
          obj.no = data.no;
          obj.botAmount = data.botAmount + "Bot";
          obj.term = data.term + "년";
          obj.licenseNumber = data.licenseNumber;
          obj.botCheck =
            data.botList.length + "Bot / " + data.botAmount + "Bot";
          obj.companyName = data.user.companyName;
          obj.loginId = data.user.loginId;
          obj.useDate =
            Moment(data.startAt).format("YYYY-MM-DD") +
            " ~ " +
            Moment(data.endAt).format("YYYY-MM-DD");
          obj.botStatus =
            Moment(data.endAt).format("YYYY-MM-DD") < nowDate
              ? "expire"
              : data.status;

          obj.createdAt = data.createdAt
            ? Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
            : "-";
          obj.botList = data.botList;
          obj.memo = data.memo;
          list.push(obj);
        }
      });
      setLicenseList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    setListLoading(true);
    setTimeout(async () => {
      fetchData();
      setListLoading(false);
    }, 1500);
  }, []);

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const toggleAddShow = () => {
    setIsAddShow(!isAddShow);
  };

  const toggleFindIdShow = () => {
    setIsFindIdShow(!isFindIdShow);
  };

  const doUse = async (value) => {
    const param = {
      status: "Y",
    };

    const res = await uptLicense(value, param);
    // console.log("doUse", res);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      if (selectBot) {
        fetchData(selectBot);
      } else {
        fetchData();
      }
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return;
    }
  };

  const doNoUse = async (value) => {
    const param = {
      status: "N",
    };
    const res = await uptLicense(value, param);
    // console.log("doNoUse", res);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      if (selectBot) {
        fetchData(selectBot);
      } else {
        fetchData();
      }
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return;
    }
  };

  const licenseDetail = async (value) => {
    console.log("수정수정");
    const res = await getLicenseDetail(value);

    console.log("getLicenseDetail", res);

    setLicenseNo(res.data.no);
    setInput({
      botAmount: res.data.botAmount,
      term: res.data.term,
      startDate: res.data.startAt,
      endDate: res.data.endAt,
      licenseNumber: res.data.licenseNumber,
      status: res.data.status,
      memo: res.data.memo,
      loginId: res.data.user.loginId,
      companyName: res.data.user.companyName,
    });
    setIsAdd(true);
    toggleAddShow();
  };

  const delLicense = async (value) => {
    if (window.confirm("라이선스를 삭제하시겠습니까?")) {
      const res = await deleteLicense(value);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        if (selectBot) {
          fetchData(selectBot);
        } else {
          fetchData();
        }
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return;
      }
    }
  };

  const columns = [
    // {
    // 	name: "idx",
    // 	label: "번호",
    // 	options: {
    // 		filter: true,
    // 		sort: true,
    // 		setCellProps: () => ({ style: { textAlign: "center" } }),
    // 		setCellHeaderProps: () => ({
    // 			className: classes.centeredHeader,
    // 		}),
    // 	},
    // },
    {
      name: "botAmount",
      label: "Bot 수",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "term",
      label: "사용기간",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "useDate",
      label: "유효기간",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "licenseNumber",
      label: "라이선스",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "botList",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "botStatus",
      label: "라이선스 상태",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
          let textLabel;
          let textColor;

          if (value === "Y") {
            textLabel = "사용";
            textColor = "label-success";
          } else if (value === "N") {
            textLabel = "사용중지";
            textColor = "label-primary";
          } else if (value === "expire") {
            textLabel = "기간만료";
            textColor = "label-secondary";
          }
          return (
            <div>
              <span className={"label label-xl label-inline " + textColor}>
                {textLabel}
              </span>
            </div>
          );
        },
      },
    },
    {
      name: "botCheck",
      label: "Bot 확인",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: {
            textAlign: "center",
            fontWeight: "bold",
            textDecorationLine: "underline",
          },
        }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "no",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "companyName",
      label: "고객사명",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "loginId",
      label: "ID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "memo",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "action",
      label: "작업",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center", fontSize: 15, fontWeight: "bold" },
        }),
        customBodyRender: (value, meta) => {
          // console.log("metameta", meta);
          // if (userNo.toString() === meta.rowData[6].toString()) {
          return (
            <div className="card-toolbar">
              <Dropdown className="dropdown-inline">
                <Dropdown.Toggle
                  className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                  variant="transparent"
                  id="dropdown-autoClose-true"
                  as={DropdownCustomToggler}
                >
                  <i className="ki ki-bold-more-hor" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                  {/* <ul className="navi"> */}
                  {meta.rowData[5] !== "expire" && (
                    <div>
                      <Dropdown.Item
                        className="navi-item"
                        onClick={() => {
                          console.log("사용", meta.rowData);
                          doUse(meta.rowData[7]);
                        }}
                      >
                        사용
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="navi-item"
                        onClick={() => {
                          console.log("사용중지", meta.rowData);
                          doNoUse(meta.rowData[7]);
                        }}
                      >
                        사용중지
                      </Dropdown.Item>
                    </div>
                  )}

                  <Dropdown.Item
                    className="navi-item"
                    onClick={() => {
                      licenseDetail(meta.rowData[7]);
                      console.log("수정", meta.rowData);
                    }}
                  >
                    수정
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="navi-item"
                    onClick={() => {
                      delLicense(meta.rowData[7]);
                    }}
                  >
                    삭제
                  </Dropdown.Item>
                  {/* </ul> */}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
          // }
        },
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    rowsPerPage: 15,
    rowsPerPageOptions: [],
    selectToolbarPlacement: "none",
    selectableRows: "none",
    onCellClick: (cellData, cellMeta) => {
      if (cellMeta.colIndex === 6) {
        toggleShow();
      }
    },
      onRowClick: (rowData, rowState) => {
      setBotStatus(licenseList[rowState.rowIndex].botStatus);
      setSelectRowData(rowData);
      setBotList(rowData[4]);
    },
    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : licenseList && licenseList.length > 0 ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  const addLicense = () => {
    console.log("1111");
  };

  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const handleEndDate = (e) => {
    if (e.target.name === "term") {
      setInput({
        ...input,
        endDate: Moment(input.startDate)
          .add("365" * e.target.value, "d")
          .format("YYYY-MM-DD"),
        [e.target.name]: e.target.value,
      });
      console.log("input.term", input.term);
    }
    if (e.target.name === "startDate") {
      console.log("input.term", input.term);
      setInput({
        ...input,
        endDate: Moment(e.target.value)
          .add("365" * input.term, "d")
          .format("YYYY-MM-DD"),
        [e.target.name]: e.target.value,
      });
    }
  };

  const generateLicense = async () => {
    const res = await createLicenseKey();

    if (res.result) {
      setInput({
        ...input,
        licenseNumber: res.data.code,
      });
      setOkLicense(true);
    } else {
      alert("라이선스 생성 오류");
      return false;
    }
  };

  const findUser = async () => {
    const res = await findLoginId(input.loginId);
    console.log("findLoginId", res);
    setFindIdList(res.data);
  };

  const selectFindId = (userNo, loginId, companyName) => {
    setInput({
      ...input,
      loginId: loginId,
      companyName: companyName,
    });

    setFindId(userNo);
  };

  const regLicense = async () => {
    if (input.botAmount === undefined || input.botAmount === "") {
      setConfirmBotAmount(true);
      return false;
    } else {
      setConfirmBotAmount(false);
    }

    if (input.term === undefined || input.term === "") {
      setConfirmTerm(true);
      return false;
    } else {
      setConfirmTerm(false);
    }
    if (input.licenseNumber === undefined || input.licenseNumber === "") {
      setConfirmLicenseNumber(true);
      return false;
    } else {
      setConfirmLicenseNumber(false);
    }
    if (input.loginId === undefined || input.loginId === "") {
      setConfirmLoginId(true);
      return false;
    } else {
      setConfirmLoginId(false);
    }

    const param = {
      userNo: findId,
      licenseNumber: input.licenseNumber,
      term: input.term,
      botAmount: input.botAmount,
      startAt: input.startDate,
      endAt: input.endDate,
      status: input.status,
      memo: input.memo,
    };

    const res = await insertLicense(param);
    toggleAddShow();
    setInput({
      botAmount: "",
      term: "",
      startDate: Moment(new Date()).format("YYYY-MM-DD"),
      endDate: Moment(new Date()).format("YYYY-MM-DD"),
      licenseNumber: "",
      status: "Y",
      memo: "",
    });
    if (res.result) {
      alert("정상적으로 등록되었습니다.");
      if (selectBot) {
        fetchData(selectBot);
      } else {
        fetchData();
      }
    } else {
      alert("정상적으로 등록되지 않았습니다.");
      return;
    }
  };

  const updateLicense = async () => {
    if (input.botAmount === undefined || input.botAmount === "") {
      setConfirmBotAmount(true);
      return false;
    } else {
      setConfirmBotAmount(false);
    }

    if (input.term === undefined || input.term === "") {
      setConfirmTerm(true);
      return false;
    } else {
      setConfirmTerm(false);
    }

    const param = {
      term: input.term,
      botAmount: input.botAmount,
      startAt: input.startDate,
      endAt: input.endDate,
      status: input.status,
      memo: input.memo,
    };

    const res = await uptLicense(licenseNo, param);
    toggleAddShow();
    setInput({
      botAmount: "",
      term: "",
      startDate: Moment(new Date()).format("YYYY-MM-DD"),
      endDate: Moment(new Date()).format("YYYY-MM-DD"),
      licenseNumber: "",
      status: "Y",
      memo: "",
    });
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      // console.log(selectBot);
      if (selectBot) {
        fetchData(selectBot);
      } else {
        fetchData();
      }
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return;
    }
  };

  const selectBotAdmin = (e) => {
    console.log("eeeee", e.target.value);
    setSelectBot(e.target.value);
    fetchData(e.target.value);
  };

  return (
    <div id="pageid31">
      <Modal show={isShow}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Bot 확인</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="d-flex align-items-center justify-content-between mb-5">
            <p className="mb-0 license-number">{selectRowData[3]}</p>
            <p className="mb-0 font-weight-bold">{selectRowData[6]} ({selectRowData[1]})</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Bot ID</th>
                <th>Bot 상태</th>
              </tr>
            </thead>
            <tbody>
              {botList.length > 0 &&
                botList.map((data, index) => {
                  let textLabel;
                  let textColor;

                    if (botStatus == "N") {
                        textLabel = "사용중지";
                        textColor = "label-primary";
                    }
                    else if (botStatus == "expire") {
                        textLabel = "기간만료";
                        textColor = "label-secondary";
                    }
                    else {
                        if (data.accountStatus === 2) {
                            textLabel = "사용";
                            textColor = "label-success";
                        } else if (data.accountStatus === 1) {
                            textLabel = "사용중지";
                            textColor = "label-primary";
                        } else if (data.accountStatus === 3) {
                            textLabel = "기간만료";
                            textColor = "label-secondary";
                        }
                    }
                  return (
                    <tr>
                      <td>{data.loginId}</td>
                      <td>
                        <span
                          className={"label label-xl label-inline " + textColor}
                        >
                          {textLabel}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              {botList.length === 0 && (
                <tr>
                  <td colSpan="2">
                    <span>등록된 Bot이 없습니다.</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={isAddShow} aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {isAdd ? "라이선스 수정" : "라이선스 추가"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <p>Bot 수</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Bot수를 입력해주세요."
              type="number"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="botAmount"
              min={1}
              value={input.botAmount || ""}
              onChange={(e) => handleChange(e)}
            />
            {confirmBotAmount ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-danger mt-1 font-size-sm">
                  Bot 수를 입력해 주세요.
                </div>
              </div>
            ) : null}
          </div>
          <p>사용 기간(년)</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="사용 기간을 입력해주세요."
              type="number"
              min={1}
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="term"
              value={input.term || ""}
              onChange={(e) => {
                handleChange(e);
                handleEndDate(e);
              }}
            />
            {confirmTerm ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-danger mt-1 font-size-sm">
                  사용 기간을 입력해 주세요.
                </div>
              </div>
            ) : null}
          </div>
          <p>유효 기간</p>
          <div
            className="row form-group fv-plugins-icon-container"
            style={{ marginLeft: 10 }}
          >
            <div>
              <TextField
                id="startDate"
                type="date"
                name="startDate"
                // defaultValue={startDate}
                value={input.startDate || ""}
                onChange={(e) => {
                  handleChange(e);
                  handleEndDate(e);
                }}
                // value: Moment(recordAt).format("YYYY-MM-DD") || "",
                // defaultValue="2021-05-24"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div style={{ marginLeft: 15, marginRight: 15, paddingTop: 5 }}>
              ~
            </div>
            <div>
              <TextField
                id="endDate"
                type="date"
                name="endDate"
                disabled={true}
                value={input.endDate || ""}
                onChange={(e) => handleChange(e)}
                className={classes.textField}
                style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          <p>라이선스</p>
          <div className="form-group fv-plugins-icon-container">
            <div className="d-flex align-items-center justify-content-between">
              <input
                placeholder=""
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                name="licenseNumber"
                style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
                disabled
                value={input.licenseNumber || ""}
              />
              <Button
                className={`btn btn-primary font-weight-bold text-white ml-2`}
                onClick={() => {
                  generateLicense();
                }}
                disabled={okLicense || isAdd ? true : false}
              >
                라이선스 생성
              </Button>
            </div>
            {confirmLicenseNumber ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-danger mt-1 font-size-sm">
                  라이센스를 생성해 주세요.
                </div>
              </div>
            ) : null}
          </div>
          <p>상태</p>
          <div className="form-group fv-plugins-icon-container">
            <select
              className="form-control form-control-lg form-control-solid"
              name="status"
              onChange={(e) => handleChange(e)}
              value={input.status}
            >
              <option value="Y">사용</option>
              <option value="N">사용중지</option>
            </select>
          </div>
          <p>ID</p>
          <div className="form-group fv-plugins-icon-container">
            <div className="d-flex align-items-center justify-content-between">
              <input
                placeholder=""
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                name="loginId"
                disabled
                style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
                value={input.loginId || ""}
              />
              <Button
                className={`btn btn-primary font-weight-bold text-white ml-2`}
                disabled={isAdd ? true : false}
                onClick={() => {
                  toggleAddShow();
                  toggleFindIdShow();
                }}
              >
                ID 찾기
              </Button>
            </div>
            {confirmLoginId ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-danger mt-1 font-size-sm">
                  ID 찾기를 해주세요.
                </div>
              </div>
            ) : null}
          </div>
          <p>고객사명</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder=""
              type="companyName"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="companyName"
              value={input.companyName || ""}
              disabled
              style={{ backgroundColor: "lightgrey", borderCcolor: "lightgrey" }}
            />
          </div>
          <p>메모</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              placeholder="내용을 입력해주세요."
              className="modal-textarea"
              // style={{ height: "150px" }}
              name="memo"
              value={input.memo || ""}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => {
                toggleAddShow();
                setInput({
                  botAmount: "",
                  term: "",
                  startDate: Moment(new Date()).format("YYYY-MM-DD"),
                  endDate: Moment(new Date()).format("YYYY-MM-DD"),
                  licenseNumber: "",
                  status: "Y",
                  memo: "",
                });
                setOkLicense(false);
              }}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              onClick={() => (isAdd ? updateLicense() : regLicense())}
              className="btn btn-primary btn-elevate"
            >
              저장
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={isFindIdShow} centered={false}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">ID 찾기</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <p>ID</p>
          <div className="form-group fv-plugins-icon-container">
            <div className="d-flex align-items-center justify-content-between">
              <input
                placeholder=""
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 `}
                name="loginId"
                onChange={(e) => handleChange(e)}
                value={input.loginId || ""}
              />
              <Button
                className={`btn btn-primary font-weight-bold text-white ml-2`}
                onClick={() => {
                  findUser();
                }}
              >
                ID 찾기
              </Button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>고객사명</th>
              </tr>
            </thead>
            <tbody>
              {findIdList.length > 0 &&
                findIdList.map((data, index) => {
                  return (
                    <tr
                      onClick={() =>
                        selectFindId(data.no, data.loginId, data.companyName)
                      }
                      style={{ cursor : "pointer" }}
                    >
                      <td>{data.loginId}</td>
                      <td>{data.companyName}</td>
                    </tr>
                  );
                })}
              {findIdList.length === 0 && (
                <tr>
                  <td colSpan="2">
                    <span>검색된 내역이 없습니다.</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => {
                toggleFindIdShow();
                toggleAddShow();
              }}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* D1: Bot 개수 선택 시 라이선스 상세 모달 활성화 끝 */}
      <div style={{ marginTop: 30 }}>
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          라이선스 관리
        </h3>
      </div>
      <div className="top-row gutter-b d-flex align-items-center flex-column">
        <div
          className="d-flex align-items-center justify-content-end w-100"
          style={{ marginTop: 50 }}
        >
          <div className="form-group fv-plugins-icon-container mr-5">
            <select
              className="form-control form-control-lg form-control-solid"
              style={{ borderColor: "black", width: "200px" }}
              name="botAdminList"
              onChange={(e) => selectBotAdmin(e)}
            >
              <option value="">전체</option>
              {botAdminList &&
                botAdminList.length > 0 &&
                botAdminList.map((data, index) => {
                  return <option value={data.no}>{data.loginId}</option>;
                })}
            </select>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-end w-100"
          style={{ marginTop: 15 }}
        >
          <div className="mr-5">
            <Button
              className={`btn btn-info font-weight-bolder font-size-sm mr-2`}
              onClick={() => {
                toggleAddShow();
                setIsAdd(false);
              }}
            >
              라이선스 추가
            </Button>
          </div>
        </div>
      </div>
      <div className="gutter-b">
        <div className="table-responsive">
          <MUIDataTable
            // title={"Bot 관리"}
            data={licenseList}
            columns={columns}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}
export default LicenseSysManage;
